// import Header from "@/components/Header";
import HeroSection from "./HeroSection";
 import HowItWorks from "./HowItWorks";
 import ClientsSection from "./ClientsSection";
import FeaturedTools from "./FeaturedTools";
 import Faq from "./Faq";
 import MobileApps from "./MobileApps";
import Footer from "./Footer";
// import StudentCards from "./UserProfileCard";
import "./Home.css";

const Home = () => {
  return (
    <div className="min-h-screen bg-background">
     
      <HeroSection />
      <HowItWorks />
      <ClientsSection />
      <FeaturedTools />
       <Faq />
      {/* <ClientReviews /> */}
      <MobileApps />
      <Footer />
    </div>
  );
};

export default Home;